import React, { useEffect, useState } from 'react';
import AdminSidebar from '../components/AdminSidebar';
import './AdminMaterials.css';

const AdminMaterials = () => {
  const [searchItem, setSearchItem] = useState('');
  const [searchVendor, setSearchVendor] = useState('');
  const [searchJC, setSearchJC] = useState('');
  const [allMaterials, setAllMaterials] = useState([]);
  const [filteredMaterials, setFilteredMaterials] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch all materials on first load
  useEffect(() => {
    fetch(`https://ideatorportal.in/api/get_materials.php`)
      .then(res => res.json())
      .then(data => {
        if (data.status === 'success') {
          setAllMaterials(data.materials || []);
          setFilteredMaterials(data.materials || []);
        } else {
          setAllMaterials([]);
          setFilteredMaterials([]);
        }
        setLoading(false);
      })
      .catch(() => {
        setAllMaterials([]);
        setFilteredMaterials([]);
        setLoading(false);
      });
  }, []);

  // Apply multiple filters: item, vendor, JC
  useEffect(() => {
    const filtered = allMaterials.filter((mat) => {
      return (
        mat.item_name.toLowerCase().includes(searchItem.toLowerCase()) &&
        mat.vendor_name.toLowerCase().includes(searchVendor.toLowerCase()) &&
        mat.jc_number.toLowerCase().includes(searchJC.toLowerCase())
      );
    });
    setFilteredMaterials(filtered);
  }, [searchItem, searchVendor, searchJC, allMaterials]);

  return (
    <div className="admin-layout">
      <AdminSidebar />
      <div className="materials-page">
        <h2>All Materials</h2>

        {/* Filters */}
        <div className="filters-row">
          <input
            type="text"
            className="material-search-input"
            placeholder="Search by Item Name"
            value={searchItem}
            onChange={(e) => setSearchItem(e.target.value)}
          />
          <input
            type="text"
            className="material-search-input"
            placeholder="Search by Vendor Name"
            value={searchVendor}
            onChange={(e) => setSearchVendor(e.target.value)}
          />
          <input
            type="text"
            className="material-search-input"
            placeholder="Search by JC Number"
            value={searchJC}
            onChange={(e) => setSearchJC(e.target.value)}
          />
        </div>

        {loading && <p className="loading">Loading materials...</p>}
        {!loading && filteredMaterials.length === 0 && (
          <p className="no-data">No materials found.</p>
        )}

        {!loading && filteredMaterials.length > 0 && (
          <div className="materials-table-wrapper">
            <table className="materials-table">
              <thead>
                <tr>
                  <th>Item Name</th>
                  <th>Vendor</th>
                  <th>JC Number</th>
                  <th>Price</th>
                </tr>
              </thead>
              <tbody>
                {filteredMaterials.map((mat, idx) => (
                  <tr key={idx}>
                    <td>{mat.item_name}</td>
                    <td>{mat.vendor_name}</td>
                    <td>{mat.jc_number}</td>
                    <td>₹{parseFloat(mat.price || 0).toFixed(2)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminMaterials;
